<template>
  <div class="social-hub">
    <template>
      <ProfileComponent
        style="margin-top: 64px; padding-bottom: 64px"
        v-if="viewedUserId"
        :key="viewedUserId"
        :user-id="viewedUserId"
        @close-profile="clearViewedUser"
        @view-profile="showUserProfile" />
      <v-app-bar v-if="false" dark app flat color="background" class="app-bar-border">
        <v-toolbar-title class="font-weight-bold"
          ><v-btn @click="$router.push('/friends')" icon v-if="currentViewTitle === 'Social Feed'"><v-icon>mdi-arrow-left</v-icon></v-btn
          >{{ currentViewTitle }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="requestDialog = true">
          <v-badge :content="requestCount" :value="requestCount > 0" color="error" overlap>
            <v-icon>mdi-bell-outline</v-icon>
          </v-badge>
        </v-btn>
      </v-app-bar>

      <div v-if="!viewedUserId" style="min-height: 100vh">
        <v-window touchless v-model="activeView" class="fill-height">
          <v-window-item value="feed" class="fill-height">
            <FeedComponent
              @view-profile="showUserProfile"
              :feedItems="feed"
              :loading="loading"
              @share-post="loadInitialData"
              @refresh-feed="loadInitialData"
              @post-updated="loadInitialData" />
          </v-window-item>

          <v-window-item value="gym" class="fill-height">
            <CheckedInPoolComponent @view-profile="showUserProfile" />
          </v-window-item>

          <v-window-item value="discover" class="fill-height">
            <DiscoverComponent @view-profile="showUserProfile" />
          </v-window-item>

          <v-window-item value="profile" class="fill-height">
            <ProfileComponent @view-profile="showUserProfile" v-if="myUserId" :key="myUserId" :userId="myUserId" />
          </v-window-item>
        </v-window>
      </div>
      <v-dialog v-model="requestDialog" max-width="500px">
        <v-card dark>
          <v-tabs v-model="requestTab" background-color="transparent" grow>
            <v-tab>
              Freunde
              <v-badge inline :content="friendRequests.length" :value="friendRequests.length > 0" color="primary" class="ml-2"></v-badge>
            </v-tab>
            <v-tab>
              Training
              <v-badge inline :content="trainingRequests.length" :value="trainingRequests.length > 0" color="primary" class="ml-2"></v-badge>
            </v-tab>
          </v-tabs>

          <v-tabs-items dark v-model="requestTab" class="transparent">
            <v-tab-item>
              <div v-if="friendRequests.length === 0" class="text-center pa-8 grey--text">
                <v-icon size="50" class="mb-3">mdi-account-off-outline</v-icon>
                <p>Keine offenen Freundschaftsanfragen.</p>
              </div>
              <v-list v-else color="transparent">
                <v-list-item v-for="req in friendRequests" :key="req._id">
                  <v-list-item-avatar size="50" class="cursor-pointer" @click="viewRequestProfile(req.initiator._id)">
                    <v-img :src="req.initiator.bild ? '/img/profilbilder/' + req.initiator.bild : '/img/profilbilder/default.png'"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content @click="viewRequestProfile(req.initiator._id)">
                    <v-list-item-title class="font-weight-bold">{{ req.initiator.vorname }} {{ req.initiator.nachname }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action class="d-flex align-center">
                    <v-btn icon color="success" @click="acceptFriendship(req._id)"><v-icon>mdi-check</v-icon></v-btn>
                    <v-btn icon color="error" @click="declineFriendship(req._id)"><v-icon>mdi-close</v-icon></v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-tab-item>

            <v-tab-item>
              <div v-if="trainingRequests.length === 0" class="text-center pa-8 grey--text">
                <v-icon size="50" class="mb-3">mdi-calendar-remove-outline</v-icon>
                <p>Keine offenen Trainingsanfragen.</p>
              </div>
              <v-list v-else color="transparent" three-line>
                <v-list-item v-for="req in trainingRequests" :key="req._id">
                  <v-list-item-avatar size="50" class="cursor-pointer" @click="viewRequestProfile(req.requester._id)">
                    <v-img :src="req.requester.bild ? '/img/profilbilder/' + req.requester.bild : '/img/profilbilder/default.png'"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold" @click="viewRequestProfile(req.requester._id)">
                      {{ req.requester.vorname }} {{ req.requester.nachname }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Schlägt vor: {{ req.availability.days.join(", ") }} ({{ req.availability.timeOfDay }})
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="req.message" class="mt-1 font-italic">"{{ req.message }}"</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="align-self-center">
                    <v-btn icon color="success" @click="acceptTraining(req._id)"><v-icon>mdi-check</v-icon></v-btn>
                    <v-btn icon color="error" @click="declineTraining(req._id)"><v-icon>mdi-close</v-icon></v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="requestDialog = false">Schliessen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-fab-transition v-if="!viewedUserId">
        <v-btn
          v-if="activeView === 'feed'"
          color="primary"
          dark
          style="position: fixed; bottom: 80px; left: calc(50% - 30px)"
          width="60"
          height="60"
          fab
          @click="postDialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>

      <v-dialog v-model="postDialog" max-width="500px">
        <CreatePost @close="postDialog = false" @post-created="loadInitialData" />
      </v-dialog>

      <v-bottom-navigation absolute style="top: 0" dark v-model="activeView" color="primary" app grow>
        <v-btn value="feed"> <span>Feed</span> <v-icon>mdi-home-variant</v-icon> </v-btn>
        <v-btn value="gym"> <span>Im Gym</span> <v-icon>mdi-map-marker-radius</v-icon> </v-btn>
        <v-btn value="discover"> <span>Entdecken</span> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn value="profile"> <span>Profil</span> <v-icon>mdi-account-circle</v-icon> </v-btn>
      </v-bottom-navigation>
    </template>
  </div>
</template>

<script>
import api from "@/api"
import FeedComponent from "./components/social/FeedComponent.vue"
import CheckedInPoolComponent from "./components/social/CheckedInPoolComponent.vue"
import DiscoverComponent from "./components/social/DiscoverComponent.vue"
import ProfileComponent from "./components/social/ProfileComponent.vue"
import CreatePost from "./components/social/CreatePost.vue"
import userService from "@/services/userService"
import socketService from "@/socketService" // NEU importieren
import { mapGetters, mapActions, mapState } from "vuex"

export default {
  components: { FeedComponent, DiscoverComponent, ProfileComponent, CheckedInPoolComponent, CreatePost },
  data: () => ({
    postDialog: false,
    viewedUserId: null,
    userService,
    activeView: "feed",
    feed: [],
    requestDialog: false,
    requestTab: 0,
    friendRequests: [],
    trainingRequests: [],
    loading: true,
  }),
  watch: {
    activeView() {
      this.viewedUserId = null
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationItems", "navigationVisible"]),
    myUserId() {
      return userService.getUserId()
    },
    currentViewTitle() {
      const titles = {
        feed: "Social Feed",
        gym: "Aktuell im Gym", // NEU
        discover: "Entdecken",
        profile: "Mein Profil",
      }
      return titles[this.activeView]
    },
    requestCount() {
      return this.friendRequests.length + this.trainingRequests.length
    },
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["toggleNavigationBarVisibility", "setNavigationBarText", "setNavigationbarVisibility"]),
    setupSocketListeners() {
      // Lausche auf neue Freundschaftsanfragen
      socketService.off("new_friend_request") // Sicherstellen, dass vorherige Listener entfernt werden;
      socketService.on("new_friend_request", (newRequest) => {
        // Füge die Anfrage zur Liste hinzu
        this.friendRequests.unshift(newRequest)
        // Optional: Zeige eine Snackbar/Toast-Nachricht
        //  this.$toast.info(`Neue Freundschaftsanfrage von ${newRequest.initiator.vorname}!`)
      })

      // Lausche auf angenommene Anfragen
      socketService.off("friend_request_accepted")
      socketService.on("friend_request_accepted", (data) => {
        //  this.$toast.success(data.message)
        // Lade den Feed oder die Freundesliste neu, um die Änderung anzuzeigen
        this.loadInitialData()
      })

      // Lausche auf neue Freundschaftsanfragen
      socketService.off("new_training_request")
      socketService.on("new_training_request", (newRequest) => {
        // Füge die Anfrage zur Liste hinzu
        this.trainingRequests.unshift(newRequest)
        // Optional: Zeige eine Snackbar/Toast-Nachricht
        //this.$toast.info(`Neue Freundschaftsanfrage von ${newRequest.initiator.vorname}!`)
      })

      // Lausche auf angenommene Anfragen
      socketService.off("training_request_accepted")
      socketService.on("training_request_accepted", (data) => {
        // this.$toast.success(data.message)
        // Lade den Feed oder die Freundesliste neu, um die Änderung anzuzeigen
        this.loadInitialData()
      })

      // HIER KÖNNTEST DU AUF WEITERE EVENTS LAUSCHEN
      // z.B. 'new_post_in_feed', 'new_comment', 'new_training_request'
    },
    viewRequestProfile(userId) {
      this.showRequests = false // Dialog schliessen
      this.showUserProfile(userId) // Bestehende Methode zur Profilanzeige aufrufen
    },
    showUserProfile(userId) {
      if (userId.toString() === this.myUserId.toString()) {
        this.viewedUserId = null
        this.activeView = "profile" // Zeige eigenes Profil
      } else {
        this.viewedUserId = userId
      }
    },
    // NEU: Diese Methode wird aufgerufen, wenn das Profil geschlossen wird (z.B. per "Zurück"-Button).
    clearViewedUser() {
      this.viewedUserId = null
    },
    async loadInitialData() {
      this.loading = true
      try {
        const [feedData, requestData] = await Promise.all([api.social.getFeed(), api.social.getRequestsSummary()])
        this.feed = feedData
        this.friendRequests = requestData.friendRequests
        this.trainingRequests = requestData.trainingRequests
      } catch (error) {
        console.error("Initiales Laden der Daten fehlgeschlagen:", error)
      } finally {
        this.loading = false
      }
    },
    async acceptFriendship(id) {
      await api.social.acceptRequest(id)
      this.loadInitialData() // Daten neu laden
    },
    async declineFriendship(id) {
      await api.social.removeOrDeclineRelationship(id)
      this.loadInitialData()
    },
    // NEUE Methoden für Trainingsanfragen
    async acceptTraining(id) {
      await api.social.respondToTrainingRequest(id, "accepted")
      this.loadInitialData()
    },
    async declineTraining(id) {
      await api.social.respondToTrainingRequest(id, "declined")
      this.loadInitialData()
    },
  },
  mounted() {},
  beforeDestroy() {},
  created() {
    this.loadInitialData()
    this.setupSocketListeners()
  },
}
</script>

<style scoped>
/* Verwende Vuetify-Variablen für Dark Mode Kompatibilität */
.app-bar-border {
  border-bottom: 1px solid var(--v-divider-base) !important;
}
.social-hub {
  padding-top: 60px;
  min-height: 100vh;
  background-color: #212121;
}

.social-hub,
.v-main,
.v-window,
.v-window-item {
}

.fill-height {
  height: 100%;
}
</style>
